import { Subject } from 'rxjs'

export const UserGeometryChanged = new Subject<void>()
